import { getCookie } from "@insite/client-framework/Common/Cookies";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import MobiusPage from "@insite/mobius/Page";
import getRoleBaseWebsitePages from "@tecumseh/Handlers/RoleBasePageHandler";
import { fetchAllRoles } from "@tecumseh/Services/RoleBasePageService";
import CustomApplicationState from "@tecumseh/Store/Data/CustomApplicationState/CustomApplicationState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState & CustomApplicationState, props: PageProps) => {
    const userRoles = state.context.session?.userRoles?.split(",");
    const roleBasePages = state.TECData.roleBasePages.contentResults;
    const page = state.data.pages.byId[props.id];
    return {
        page,
        userRoles,
        isLoadingRoleBasePage:  state.TECData.roleBasePages.isLoadingRoleBasePage,
    }
}
const mapDispatchToProps = {
    getRoleBaseWebsitePages
};
type OwnProps = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
const NewsListPage: React.FunctionComponent<OwnProps> = ({
    id,
    page,
    userRoles,
    isLoadingRoleBasePage,
    getRoleBaseWebsitePages,
}) => {
    const [verifiedPage, setVerifiedPage] = React.useState(true);
    React.useEffect(() => {
        getRoleBaseWebsitePages({
            onSuccess: (results: any) => {
                const data = getPage(page.nodeId, results);
                if(!getCookie("cms_CurrentContentMode")) {
                    setVerifiedPage(data ? checkUserRoles(data?.userRole): true);
                }
            }
        });
    },[page.nodeId]);

    const checkUserRoles = (role: string) => {
        const USER_ROLES = userRoles?.map((role: any) => role && role.trim().toLowerCase());
        const roles = role.split(",").map((userRole) => userRole.toLowerCase());
        let isRoleMatch = !USER_ROLES;
        isRoleMatch = roles.map((userRole) => {
            return (role && USER_ROLES) ? USER_ROLES.includes(userRole.toLowerCase()) : false;
        }).filter(userRoleFlag => userRoleFlag).length > 0;
        return isRoleMatch;
    }
    
    const getPage = (id: string, roleBasePages: any) => {
        const page = roleBasePages?.filter((rPage: any) => rPage.nodeId === id);
        return page.length > 0 ? page[0]: null;
    }

    return (
        <LoadingOverlay
            loading={isLoadingRoleBasePage}
            css={css`
                width: 100%;
            `}
        >
            <MobiusPage>
                {
                    ((!verifiedPage)) ? 
                        <> {siteMessage("authorization_message")} </> :
                    <Zone contentId={id} zoneName="Content" requireRows />
                }
            </MobiusPage>
        </LoadingOverlay>
)};
const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};
const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(NewsListPage),
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        allowedChildren: ["NewsPage"],
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                name: "userRole",
                editorTemplate: "DropDownField",
                defaultValue: "",
                fieldType: "General",
                options: async () => {
                    const roles: any = await fetchAllRoles();
                        return ["Select Value", ...roles].map((o: string) => ({
                            value: o,
                            displayName: o,
                        }));
                },
                hideEmptyOption: true,
                tab: basicTab,
            },
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "NewsListPage" instead of this constant.
 */
export const NewsListPageContext = "NewsListPage";
